import { render, staticRenderFns } from "./PopupSwapSuccessArea.vue?vue&type=template&id=7a3332a6"
import script from "./PopupSwapSuccessArea.vue?vue&type=script&lang=js"
export * from "./PopupSwapSuccessArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports